import{broadcast as o}from"./broadcast.js";import"./broadcast2child.js";import"./broadcast2parent.js";function t(t,s,r){"function"!=typeof(null==t?void 0:t.postMessage)?o(r,s):t.postMessage(JSON.stringify(s),"*")}export{t as broadcastResponse};
//# sourceMappingURL=broadcastResponse.js.map
